/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignArchivePathParams, CampaignArchiveResponse } from '../types/CampaignArchive'

/**
 * POST /campaigns/:campaign/archive
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::archive
 */
export async function campaignArchive(
	campaign: CampaignArchivePathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignArchiveResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/archive`, undefined, config)
}
